import React from 'react';
import { Account, User } from '@citrite/sf-api';
// TODO: just to remind to put loader
// import {LoadingPrimary} from '@sharefiledev/flow-web';
import type { PiletApi } from '@sharefiledev/sharefile-appshell';

// import { LocalizationLoader } from './translate';

const Context = React.createContext<AppContext>({
	piletApi: {
		Extension: () => null,
	} as any,
	user: {},
	account: {},
});

export interface AppContext {
	piletApi: PiletApi;
	user: User;
	account: Account;
}

interface AppContextProviderProps {
	piletApi: PiletApi;
	children: React.ReactNode;
}

export const AppContextProvider = (props: AppContextProviderProps) => {
	return (
		<Context.Provider
			value={{
				piletApi: props.piletApi,
				...props.piletApi.sf.piletUserContext.get(),
			}}
		>
			{props.children}
		</Context.Provider>
	);
};

export const useAppContext = () => React.useContext(Context);
